import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  BoxSeam,
  Chat,
  ExclamationSquare,
  FilePerson,
  Filter,
  Gear,
  Search,
  Square,
  Table,
} from 'react-bootstrap-icons';
import { IMAGES_REPO } from '../../../../../static-resources';
import './navigation-icon.component.scss';

export const NavigationIcon = ({
  icon,
  name,
}: {
  icon: string;
  name: string;
}) => {
  switch (icon) {
    case 'house-door':
      return (
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id="tooltip-line-chart">{name}</Tooltip>}
        >
          <div className="icon-container">
            <img src={IMAGES_REPO.HomeLineIcon} alt="" />
          </div>
        </OverlayTrigger>
      );
    case 'bar-chart':
      return (
        <div className="icon-container">
          <img src={IMAGES_REPO.BarChartLine} alt="" />
          <span className="icon-text">{name}</span>
        </div>
      );
    case 'chat':
      return (
        <div className="icon-container">
          <Chat />
          <span className="icon-text">{name}</span>
        </div>
      );
    case 'box-seam':
      return (
        <div className="icon-container">
          <BoxSeam />
          <span className="icon-text">{name}</span>
        </div>
      );
    case 'file-person':
      return (
        <div className="icon-container">
          <FilePerson />
          <span className="icon-text">{name}</span>
        </div>
      );
    case 'gear':
      return (
        <div className="icon-container">
          <Gear />
          <span className="icon-text">{name}</span>
        </div>
      );
    case 'search':
      return (
        <div className="icon-container">
          <Search />
          <span className="icon-text">{name}</span>
        </div>
      );
    case 'filter':
      return (
        <div className="icon-container">
          <Filter />
          <span className="icon-text">{name}</span>
        </div>
      );
    case 'table':
      return (
        <div className="icon-container">
          <Table />
          <span className="icon-text">{name}</span>
        </div>
      );
    case 'item':
      return (
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id="tooltip-line-chart">{name}</Tooltip>}
        >
          <div className="icon-container">
            <Square />
          </div>
        </OverlayTrigger>
      );
    case 'exclamation-square':
      return (
        <div className="icon-container">
          <ExclamationSquare />
        </div>
      );
    case 'star':
      return (
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id="tooltip-star">{name}</Tooltip>}
        >
          <div className="icon-container">
            <img src={IMAGES_REPO.StarIcon2} alt="" />
          </div>
        </OverlayTrigger>
      );
    case 'bar-chart-square-up':
      return (
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id="tooltip-bar-chart-square-up">{name}</Tooltip>}
        >
          <div className="icon-container">
            <img src={IMAGES_REPO.BarChartSquareUp} alt="" />
          </div>
        </OverlayTrigger>
      );
    case 'drill-through':
      return (
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id="tooltip-drill-through">{name}</Tooltip>}
        >
          <div className="icon-container">
            <img src={IMAGES_REPO.DrillThroughIcon} alt="" />
          </div>
        </OverlayTrigger>
      );
    case 'line-chart-up':
      return (
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id="tooltip-line-chart">{name}</Tooltip>}
        >
          <div className="icon-container">
            <img src={IMAGES_REPO.LineChartUp} alt="" />
          </div>
        </OverlayTrigger>
      );
    case 'netflow':
      return (
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id="tooltip-netflow">{name}</Tooltip>}
        >
          <div className="icon-container">
            <img src={IMAGES_REPO.NetFlow} alt="" />
          </div>
        </OverlayTrigger>
      );
    case 'planner':
      return (
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id="tooltip-planner">{name}</Tooltip>}
        >
          <div className="icon-container">
            <img src={IMAGES_REPO.PlannerIcon} alt="" />
          </div>
        </OverlayTrigger>
      );
    case 'arrow-left':
      return (
        <div className="icon-container">
          <img src={IMAGES_REPO.ArrowLeftIcon} alt="" />
          <span className="icon-text">{name}</span>
        </div>
      );
    case 'contact-us':
      return (
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id="tooltip-contact-us">{name}</Tooltip>}
        >
          <div className="icon-container">
            <img src={IMAGES_REPO.MessageQuestionCircle} alt="" />
          </div>
        </OverlayTrigger>
      );

    default:
      return <span />;
  }
};
